import React from 'react';

export default function LabelContent({ children, paddingTop }) {
	return <div style={{ padding: 'var(--u-4)', paddingTop }}>
		{children}
	</div>;
}
